import cookie from 'react-cookie';
import moment from 'moment';

class CookieItpUtils {

  static cookieDomain () {
    var domainParts = location.hostname.split('.');
    if (domainParts.length > 2) {
      domainParts.shift();
    }
    return domainParts.join('.');
  }

  static getItpCookie (name) {
    var ffItpOne = cookie.load(name);
    return ffItpOne !== undefined;
  }

  static setItpCookie (name) {
    cookie.save(name, 'true', {
      domain: this.cookieDomain(),
      expires: moment().add(90, 'days').toDate()
    });
  }
}

export default CookieItpUtils;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/utils/cookie-itp-utils.js
 **/